import React, { FC, useMemo, useCallback } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { ModalName, Route } from 'app/enums';
import { withModalOpenChecker } from 'shared/HOC/withModalOpenChecker';
import { Modal } from 'shared/components/Modal';
import { useStyles } from './WithdrawFundsConfirmedModal.style';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { modalsReducers } from 'app/store/modal/slice';
import { SUPPORT_EMAIL } from 'shared/constants';
import { modalsSelectorFactory } from 'app/store/modal/selectors';
import { WithdrawOption } from 'modules/payments/enums';

const MODAL_NAME = ModalName.BalanceWithdrawFundsConfirmed;
const CONTENT_HEIGHT = 200;

const WithdrawFundsModalConfirmedComponent: FC = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();

  const onClick = useCallback(() => dispatch(modalsReducers.closeModal(MODAL_NAME)), [dispatch]);

  const modalPayload: { withdrawOption: WithdrawOption } = useSelector(
    modalsSelectorFactory.useModalPayload(MODAL_NAME)
  );
  const withdrawOption = modalPayload?.withdrawOption;

  const content = useMemo(() => {
    switch (withdrawOption) {
      case WithdrawOption.Crypto:
        return (
          <>
            <Typography>
              OK, we are processing Your transaction! Usually it takes several minutes.
            </Typography>
            <Typography>
              You can track progress on{' '}
              <Link to={Route.PaymentTransactions} onClick={onClick} component={RouterLink}>
                Transactions page
              </Link>
              .
            </Typography>
            <Typography color="text.disabled">
              In case withdraw takes longer than 5 minutes or you did not receive funds on external
              wallet ask <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link> for help.
            </Typography>
          </>
        );
      case WithdrawOption.PaypalRequest:
        return (
          <>
            <Typography>OK, we have received your withdraw request!</Typography>
            <Typography>
              The funds have been debited from your OKLP wallet. The transaction can be found on{' '}
              <Link to={Route.PaymentTransactions} onClick={onClick} component={RouterLink}>
                Transactions page
              </Link>
              .
            </Typography>
            <Typography color="text.disabled">
              PayPal account will be credited soon. It may take up to 60 hours. In case you have any
              questions, ask <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link> for help.
            </Typography>
          </>
        );
      default:
        return <Typography>Oops, something went wrong...</Typography>;
    }
  }, [onClick, withdrawOption]);

  return (
    <Modal name={MODAL_NAME} title="Withdraw Funds - Processing" contentHeight={CONTENT_HEIGHT}>
      <Box className={classes.root} maxHeight={CONTENT_HEIGHT}>
        {content}
      </Box>
    </Modal>
  );
};

export const WithdrawFundsModalConfirmed = withModalOpenChecker(
  WithdrawFundsModalConfirmedComponent,
  MODAL_NAME
);
